import axios, {AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken} from 'axios';
import {SafeDigsClientBase, isAxiosError, throwException} from './SafeDigsClientBase';
import MNSwagClientConfiguration from '../Toolkit/Api/NSwagClientConfiguration';

export class AuditLogClient extends SafeDigsClientBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: MNSwagClientConfiguration, baseUrl?: string, instance?: AxiosInstance) {

        super(configuration);

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl('');
    }

    getDigAudit(safeDigId: number, appArea: number,cancelToken?: CancelToken | undefined): Promise<any> {
        let url_ = this.baseUrl + '/Audit/GetSafeDigAudit?id={safeDigId}&appArea={appArea}';
        if(safeDigId === undefined || safeDigId === null) {
            throw new Error('The parameter \'safeDigId\' must be defined.');
        }
        if(appArea === undefined || appArea === null) {
            throw new Error('The parameter \'appArea\' must be defined.');
        }
        url_ = url_.replace('{safeDigId}', encodeURIComponent('' + safeDigId));
        url_ = url_.replace('{appArea}', encodeURIComponent('' + appArea));
        url_ = url_.replace(/[?&]$/, '');

        let options_: AxiosRequestConfig = {
            method: 'GET',
            url: url_,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'text/plain'
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if(isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDigAudit(_response);
        });
    }

    protected processGetDigAudit(response: AxiosResponse): Promise<any> {
        const status = response.status;
        let _headers: any = {};
        if(response.headers && typeof response.headers === 'object') {
            for(let k in response.headers) {
                if(response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if(status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null as any;

            return Promise.resolve<any>(result200);

        } else if(status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        }
        return Promise.resolve<any>(null as any);
    }
};
